import { filter, includes } from 'lodash';
import { generateLocalization, generateKeys } from '../utils';
import { appropTestPoliticallyExposedReason } from './appropTest';
import { countries } from './countries';
import { yesNo } from './general';
import { nationalities } from './nationalities';
import { DateFormat } from './dateFormats';
export const corporateStepDescription = generateLocalization('corporateStepDescription', generateKeys({
    general: {
        value: 'general',
        localization: { id: '', defaultMessage: '' },
        label: 'General information about the company',
    },
    beneficiariesDirectors: {
        value: 'beneficiariesDirectors',
        localization: { id: '', defaultMessage: '' },
        label: 'Individuals and companies holding more than 25% of the shares',
    },
    representative: {
        value: 'representative',
        localization: { id: '', defaultMessage: '' },
        label: 'Personal information of the individual who trades',
    },
    financialInformation: {
        value: 'financialInformation',
        localization: { id: '', defaultMessage: '' },
        label: 'Financial profile, means of payment, etc',
    },
    appropiatenessTest: {
        value: 'appropiatenessTest',
        localization: { id: '', defaultMessage: '' },
        label: 'Filled in for the Representative',
    },
    documents: {
        value: 'documents',
        localization: { id: '', defaultMessage: '' },
        label: 'KYC, Certificate of incorporation, etc',
    },
    signing: {
        value: 'signing',
        localization: { id: '', defaultMessage: '' },
        label: 'Declaration of the Ultimate Beneficial Owner and the Representative assignment resolution',
    },
}));
export const corporateStepCardLabel = generateLocalization('corporateStepCardLabel', generateKeys({
    general: {
        value: 'general',
        localization: { id: '', defaultMessage: '' },
        label: 'Company profile',
    },
    beneficiariesDirectors: {
        value: 'beneficiariesDirectors',
        localization: { id: '', defaultMessage: '' },
        label: 'Beneficiaries/directors',
    },
    representative: {
        value: 'representative',
        localization: { id: '', defaultMessage: '' },
        label: 'Representative’s profile',
    },
    financialInformation: {
        value: 'financialInformation',
        localization: { id: '', defaultMessage: '' },
        label: 'Financial information',
    },
    appropiatenessTest: {
        value: 'appropiatenessTest',
        localization: { id: '', defaultMessage: '' },
        label: 'Appropriateness Test',
    },
    documents: {
        value: 'documents',
        localization: { id: '', defaultMessage: '' },
        label: 'Company Documents',
    },
    signing: {
        value: 'signing',
        localization: { id: '', defaultMessage: '' },
        label: 'Signatures',
    },
}));
export const corporateStepsTooltips = generateLocalization('corporateStepsTooltips', generateKeys({
    financialInformation: {
        value: 'financialInformation',
        localization: { id: '', defaultMessage: '' },
        label: 'Financial information is data about the monetary transactions of a person or business. This information is use to derive estimates of credit risk by creditors and lenders.',
    },
}));
export const corporateSteps = generateLocalization('corporateSteps', generateKeys({
    general: {
        value: 'general',
        localization: { id: '', defaultMessage: '' },
        label: 'General',
        rank: 1,
        name: 'company_profile',
        description: corporateStepDescription.general,
        cardLabel: corporateStepCardLabel.general,
        internal: true,
    },
    beneficiariesDirectors: {
        value: 'beneficiariesDirectors',
        localization: { id: '', defaultMessage: '' },
        label: 'Beneficiaries / Directors',
        rank: 2,
        name: 'beneficiaries_directors',
        description: corporateStepDescription.beneficiariesDirectors,
        cardLabel: corporateStepCardLabel.beneficiariesDirectors,
        internal: true,
    },
    representative: {
        value: 'representative',
        localization: { id: '', defaultMessage: '' },
        label: 'Representative',
        rank: 3,
        name: 'representative',
        description: corporateStepDescription.representative,
        cardLabel: corporateStepCardLabel.representative,
        internal: true,
    },
    financialInformation: {
        value: 'financialInformation',
        localization: { id: '', defaultMessage: '' },
        label: 'Financial Information',
        rank: 4,
        name: 'financial_information',
        description: corporateStepDescription.financialInformation,
        cardLabel: corporateStepCardLabel.financialInformation,
        internal: true,
    },
    appropiatenessTest: {
        value: 'appropiatenessTest',
        localization: { id: '', defaultMessage: '' },
        label: 'Appropiateness Test',
        rank: 5,
        description: corporateStepDescription.appropiatenessTest,
        cardLabel: corporateStepCardLabel.appropiatenessTest,
    },
    documents: {
        value: 'documents',
        localization: { id: '', defaultMessage: '' },
        label: 'Documents',
        rank: 6,
        description: corporateStepDescription.documents,
        cardLabel: corporateStepCardLabel.documents,
        allowDocuments: true,
    },
    signing: {
        value: 'signing',
        localization: { id: '', defaultMessage: '' },
        label: 'Signing',
        rank: 7,
        description: corporateStepDescription.signing,
        cardLabel: corporateStepCardLabel.signing,
        allowDocuments: true,
    },
}));
export const corporateSubLabels = generateLocalization('corporateSubLabels', generateKeys({
    headOfficeAddress: {
        value: 'headOfficeAddress',
        localization: { id: '', defaultMessage: '' },
        label: 'Head office address',
    },
}));
export const corporateStepCategories = generateLocalization('corporateStepCategories', generateKeys({
    mainInformation: {
        value: 'mainInformation',
        localization: { id: '', defaultMessage: '' },
        label: 'Main Information',
        steps: [corporateSteps.general],
    },
    registrationDetails: {
        value: 'registrationDetails',
        localization: { id: '', defaultMessage: '' },
        label: 'Registration/Incorporation details',
        steps: [corporateSteps.general],
    },
    contactDetailsHeadOffice: {
        value: 'contactDetailsHeadOffice',
        localization: { id: '', defaultMessage: '' },
        label: 'Contact Details',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        subLabel: corporateSubLabels.headOfficeAddress,
    },
    correspondenceAddress: {
        value: 'correspondenceAddress',
        localization: { id: '', defaultMessage: '' },
        label: 'Correspondence address',
        steps: [corporateSteps.general],
    },
    professionalEducationalBackground: {
        value: 'professionalEducationalBackground',
        localization: { id: '', defaultMessage: '' },
        label: 'Professional and educational background',
        steps: [corporateSteps.beneficiariesDirectors],
    },
    financialProfile: {
        value: 'financialProfile',
        localization: { id: '', defaultMessage: '' },
        label: 'Financial profile per last year',
        steps: [corporateSteps.financialInformation],
        tooltip: corporateStepsTooltips.financialInformation,
    },
    meansOfPayment: {
        value: 'financialProfile',
        localization: { id: '', defaultMessage: '' },
        label: 'Means of payment',
        steps: [corporateSteps.financialInformation],
    },
    contactDetails: {
        value: 'contactDetails',
        localization: { id: '', defaultMessage: '' },
        label: 'Contact Details',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
    },
    contactDetailsAddress: {
        value: 'contactDetailsAddress',
        localization: { id: '', defaultMessage: '' },
        label: 'Residential Address',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
    },
}));
export const corporateSubCategories = generateLocalization('corporateSubCategories', generateKeys({
    detailsOriginOfFunds: {
        value: 'detailsOriginOfFunds',
        localization: { id: '', defaultMessage: '' },
        label: 'Please provide us with further details of your expected origin of funds',
    },
    expectedPaymentsDestination: {
        value: 'expectedPaymentsDestination',
        localization: { id: '', defaultMessage: '' },
        label: 'What is your expected destination of outgoing transfers/payments, if different than the expected origin of funds stated above?',
    },
    detailsSourceOfWealth: {
        value: 'detailsSourceOfWealth',
        localization: { id: '', defaultMessage: '' },
        label: 'Please provide us with details of the source of your wealth and income',
    },
}));
export const beneficiaryTypeOptions = generateLocalization('beneficiaryTypeOptions', generateKeys({
    individual: {
        value: 'individual',
        localization: { id: '', defaultMessage: '' },
        label: 'Individual',
    },
    company: {
        value: 'company',
        localization: { id: '', defaultMessage: '' },
        label: 'Company',
    },
}));
export const relationTypeOptions = generateLocalization('relationTypeOptions', generateKeys({
    shareholder: {
        value: 'shareholder',
        localization: { id: '', defaultMessage: '' },
        label: 'Shareholder',
    },
    director: {
        value: 'director',
        localization: { id: '', defaultMessage: '' },
        label: 'Director',
    },
}));
const tooltipsCorporate = generateLocalization('tooltipsCorporate', generateKeys({
    pep: {
        value: 'pep',
        localization: { id: '', defaultMessage: '' },
        label: 'A person who has been entrusted with a prominent public function.',
    },
    capacity: {
        value: 'capacity',
        localization: { id: '', defaultMessage: '' },
        label: 'Representative’s position in the company',
    },
}));
export const companyAppliesOptions = generateLocalization('companyAppliesOptions', generateKeys({
    balanceSheetTwentyMillion: {
        value: 'balanceSheetTwentyMillion',
        localization: { id: '', defaultMessage: '' },
        label: 'Balance sheet total of at least EUR 20,000,000',
    },
    netTurnoverFortyMillion: {
        value: 'netTurnoverFortyMillion',
        localization: { id: '', defaultMessage: '' },
        label: 'Net turnover of at least EUR 40,000,000',
    },
    ownFundsTwoMillion: {
        value: 'ownFundsTwoMillion',
        localization: { id: '', defaultMessage: '' },
        label: 'Own funds of at least EUR 2,000,000',
    },
}));
export const expectedCreditOptions = generateLocalization('expectedCreditOptions', generateKeys({
    bankWire: {
        value: 'bankWire',
        localization: { id: '', defaultMessage: '' },
        label: 'Bank Wire',
    },
    creditDebitCard: {
        value: 'creditDebitCard',
        localization: { id: '', defaultMessage: '' },
        label: 'Credit / Debit Card',
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
    },
}));
export const capacityOptions = generateLocalization('capacityOptions', generateKeys({
    beneficialOwner: {
        value: 'beneficialOwner',
        localization: { id: '', defaultMessage: '' },
        label: 'Beneficial Owner',
    },
    director: {
        value: 'director',
        localization: { id: '', defaultMessage: '' },
        label: 'Director',
    },
    employee: {
        value: 'employee',
        localization: { id: '', defaultMessage: '' },
        label: 'Employee',
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
    },
}));
export const corporateStatuses = generateLocalization('corporateStatuses', generateKeys({
    pending: {
        value: 'pending',
        label: 'Pending',
        localization: { id: '', defaultMessage: '' },
    },
    approved: {
        value: 'approved',
        label: 'Approved',
        localization: { id: '', defaultMessage: '' },
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const multipleLabelOptions = generateLocalization('multipleLabelOptions', generateKeys({
    taxCountry: {
        value: 'taxCountry',
        localization: { id: '', defaultMessage: '' },
        label: 'Tax country',
    },
    origin: {
        value: 'origin',
        localization: { id: '', defaultMessage: '' },
        label: 'Origin',
    },
    destination: {
        value: 'destination',
        localization: { id: '', defaultMessage: '' },
        label: 'Destination',
    },
    source: {
        value: 'source',
        localization: { id: '', defaultMessage: '' },
        label: 'Source',
    },
}));
export const corporateFields = generateLocalization('corporateFields', generateKeys({
    beneficiaryType: {
        value: 'beneficiaryType',
        localization: { id: '', defaultMessage: '' },
        label: 'Beneficiary / director type',
        steps: [corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.mainInformation.key],
        dropdown: true,
        options: beneficiaryTypeOptions,
        required: () => true,
        relevant: () => false,
    },
    companyName: {
        value: 'companyName',
        localization: { id: '', defaultMessage: '' },
        label: 'Company Name',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
    },
    firstName: {
        value: 'firstName',
        localization: { id: '', defaultMessage: '' },
        label: 'First Name',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank;
        },
        relevant: () => false,
        memberField: (step) => {
            return step === corporateSteps.representative.rank && 'firstName';
        },
    },
    lastName: {
        value: 'lastName',
        localization: { id: '', defaultMessage: '' },
        label: 'Last Name',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank;
        },
        relevant: () => false,
        memberField: (step) => {
            return step === corporateSteps.representative.rank && 'lastName';
        },
    },
    relationType: {
        value: 'relationType',
        localization: { id: '', defaultMessage: '' },
        label: 'Relation Type',
        steps: [corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.mainInformation.key],
        multiselect: true,
        options: relationTypeOptions,
        required: (answers) => {
            return answers.beneficiaryType;
        },
        relevant: (answers) => {
            return answers.beneficiaryType;
        },
    },
    percentageHolding: {
        value: 'percentageHolding',
        localization: { id: '', defaultMessage: '' },
        label: 'Percentage of total holding',
        steps: [corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: (answers, field = 'value') => {
            const answer = beneficiaryTypeOptions.company;
            return includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
    },
    tradeName: {
        value: 'tradeName',
        localization: { id: '', defaultMessage: '' },
        label: 'Trade Name (if any)',
        steps: [corporateSteps.general],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: () => false,
        relevant: () => true,
    },
    leiNumber: {
        value: 'leiNumber',
        localization: { id: '', defaultMessage: '' },
        label: 'LEI number (if applicable)',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: () => false,
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
    },
    capacity: {
        value: 'capacity',
        localization: { id: '', defaultMessage: '' },
        label: 'Capacity',
        steps: [corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        dropdown: true,
        options: capacityOptions,
        required: () => true,
        relevant: () => false,
        tooltip: tooltipsCorporate.capacity,
    },
    capacityOther: {
        value: 'capacityOther',
        localization: { id: '', defaultMessage: '' },
        label: 'please specify',
        steps: [corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: (answers, field = 'value', _) => {
            const answer = capacityOptions.other;
            return includes(answers.capacity, answer[field]);
        },
        relevant: () => false,
    },
    nationality: {
        value: 'nationality',
        localization: { id: '', defaultMessage: '' },
        label: 'Nationality',
        steps: [corporateSteps.representative],
        dropdown: true,
        options: nationalities,
        categories: [corporateStepCategories.mainInformation.key],
        required: () => true,
        relevant: () => false,
    },
    passportId: {
        value: 'passportId',
        localization: { id: '', defaultMessage: '' },
        label: 'Passport number or ID number',
        steps: [corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: () => true,
        relevant: () => false,
    },
    placeOfBirth: {
        value: 'placeOfBirth',
        localization: { id: '', defaultMessage: '' },
        label: 'Place of birth',
        steps: [corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: () => true,
        relevant: () => false,
    },
    taxCountry: {
        value: 'taxCountry',
        localization: { id: '', defaultMessage: '' },
        label: 'Tax country',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.mainInformation.key],
        required: (answers, _, step) => {
            return step === corporateSteps.general.rank || answers.beneficiaryType || step === corporateSteps.representative.rank;
        },
        relevant: () => false,
        isCountry: true,
        multiple: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return !answers.noTin && (step === corporateSteps.representative.key || (includes(answers.beneficiaryType, answer[field]))) && 2;
        },
    },
    tin: {
        value: 'tin',
        localization: { id: '', defaultMessage: '' },
        label: 'Tax identification number (TIN)',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: (answers, _, step) => {
            return step === corporateSteps.general.rank || ((answers.beneficiaryType || step === corporateSteps.representative.rank) && !answers.noTin);
        },
        relevant: () => false,
        multipleLabel: multipleLabelOptions.taxCountry,
    },
    noTin: {
        value: 'noTin',
        localization: { id: '', defaultMessage: '' },
        label: 'This person doesn\'t have TIN',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        checkbox: true,
        required: () => false,
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return step === corporateSteps.representative.rank || includes(answers.beneficiaryType, answer[field]);
        },
    },
    taxCountry1: {
        value: 'taxCountry1',
        localization: { id: '', defaultMessage: '' },
        label: 'Tax country 2',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.mainInformation.key],
        required: () => false,
        relevant: (answers, _, __, hidden) => {
            return !answers.noTin && includes(hidden, 'taxCountry1');
        },
        isCountry: true,
        isHidden: true,
    },
    tin1: {
        value: 'tin1',
        localization: { id: '', defaultMessage: '' },
        label: 'Tax identification number (TIN) 2',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: (answers, _, __, hidden) => {
            return !answers.noTin && includes(hidden, 'taxCountry1') && answers.taxCountry1;
        },
        relevant: (answers, _, __, hidden) => {
            return !answers.noTin && includes(hidden, 'taxCountry1');
        },
    },
    taxCountry2: {
        value: 'taxCountry2',
        localization: { id: '', defaultMessage: '' },
        label: 'Tax country 3',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.mainInformation.key],
        required: () => false,
        relevant: (answers, _, __, hidden) => {
            return !answers.noTin && includes(hidden, 'taxCountry2');
        },
        isCountry: true,
        isHidden: true,
    },
    tin2: {
        value: 'tin2',
        localization: { id: '', defaultMessage: '' },
        label: 'Tax identification number (TIN) 3',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: (answers, _, __, hidden) => {
            return !answers.noTin && includes(hidden, 'taxCountry2') && answers.taxCountry2;
        },
        relevant: (answers, _, __, hidden) => {
            return !answers.noTin && includes(hidden, 'taxCountry2');
        },
    },
    registrationIncorporationNumber: {
        value: 'registrationIncorporationNumber',
        localization: { id: '', defaultMessage: '' },
        label: 'Registration / Incorporation Number',
        steps: [corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.mainInformation.key],
        textfield: true,
        required: (answers, field = 'value') => {
            const answer = beneficiaryTypeOptions.company;
            return includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
    },
    politicallyExposedPerson: {
        value: 'politicallyExposedPerson',
        localization: { id: '', defaultMessage: '' },
        label: 'Politically exposed person',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        dropdown: true,
        options: yesNo,
        categories: [corporateStepCategories.mainInformation.key],
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank;
        },
        relevant: () => false,
        tooltip: tooltipsCorporate.pep,
        alert: (value) => yesNo.yes.value === value,
    },
    politicallyExposedReason: {
        value: 'politicallyExposedReason',
        localization: { id: '', defaultMessage: '' },
        label: 'Politically exposed reason',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        dropdown: true,
        options: appropTestPoliticallyExposedReason,
        categories: [corporateStepCategories.mainInformation.key],
        required: () => false,
        relevant: () => false,
        isHidden: true,
    },
    profession: {
        value: 'profession',
        localization: { id: '', defaultMessage: '' },
        label: 'Profession',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        textfield: true,
        categories: [corporateStepCategories.professionalEducationalBackground.key],
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank;
        },
        relevant: () => false,
    },
    employerBusinessName: {
        value: 'employerBusinessName',
        localization: { id: '', defaultMessage: '' },
        label: 'Employer or own business name',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        textfield: true,
        categories: [corporateStepCategories.professionalEducationalBackground.key],
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank;
        },
        relevant: () => false,
    },
    otherOccupation: {
        value: 'otherOccupation',
        localization: { id: '', defaultMessage: '' },
        label: 'Other occupation(-s), if any',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        textfield: true,
        categories: [corporateStepCategories.professionalEducationalBackground.key],
        required: () => false,
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank;
        },
    },
    qualifications: {
        value: 'qualifications',
        localization: { id: '', defaultMessage: '' },
        label: 'Do you hold any educational or professional qualifications relevant to the type of trading/service you intend to carry with us on behalf of the person whom you represent?',
        steps: [corporateSteps.representative],
        dropdown: true,
        options: yesNo,
        categories: [corporateStepCategories.professionalEducationalBackground.key],
        required: () => true,
        relevant: () => false,
        longLabel: true,
    },
    qualificationsMore: {
        value: 'qualificationsMore',
        localization: { id: '', defaultMessage: '' },
        label: 'Education or professional qualifications',
        steps: [corporateSteps.representative],
        textfield: true,
        categories: [corporateStepCategories.professionalEducationalBackground.key],
        required: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.qualifications, answer[field]);
        },
        relevant: () => false,
    },
    pastOccupation: {
        value: 'pastOccupation',
        localization: { id: '', defaultMessage: '' },
        label: 'Was your past occupation(s) within or related to the financial sector?',
        steps: [corporateSteps.representative],
        dropdown: true,
        options: yesNo,
        categories: [corporateStepCategories.professionalEducationalBackground.key],
        required: () => true,
        relevant: () => false,
    },
    pastOccupationMore: {
        value: 'pastOccupationMore',
        localization: { id: '', defaultMessage: '' },
        label: 'Past occupation(s) within or related to the financial sector',
        steps: [corporateSteps.representative],
        textfield: true,
        categories: [corporateStepCategories.professionalEducationalBackground.key],
        required: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.pastOccupation, answer[field]);
        },
        relevant: () => false,
    },
    natureOfBusinessActivities: {
        value: 'natureOfBusinessActivities',
        localization: { id: '', defaultMessage: '' },
        label: 'Nature of business activities',
        steps: [corporateSteps.general],
        textfield: true,
        categories: [corporateStepCategories.mainInformation.key],
        required: () => true,
        relevant: () => false,
    },
    authorizedRegulatedService: {
        value: 'authorizedRegulatedService',
        localization: { id: '', defaultMessage: '' },
        label: 'Are you authorized to perform any regulated service / activity?',
        steps: [corporateSteps.general],
        dropdown: true,
        options: yesNo,
        categories: [corporateStepCategories.mainInformation.key],
        required: () => true,
        relevant: () => false,
    },
    companyApplies: {
        value: 'companyApplies',
        localization: { id: '', defaultMessage: '' },
        label: 'Please indicate if any of the following applies to the company:',
        steps: [corporateSteps.financialInformation],
        options: companyAppliesOptions,
        categories: [corporateStepCategories.mainInformation.key],
        required: () => true,
        relevant: () => false,
        multipleCheckbox: true,
    },
    authorizedService: {
        value: 'authorizedService',
        localization: { id: '', defaultMessage: '' },
        label: 'Authorized service/activity',
        steps: [corporateSteps.general],
        textfield: true,
        categories: [corporateStepCategories.mainInformation.key],
        required: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.authorizedRegulatedService, answer[field]);
        },
        relevant: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.authorizedRegulatedService, answer[field]);
        },
    },
    competentAuthority: {
        value: 'competentAuthority',
        localization: { id: '', defaultMessage: '' },
        label: 'Competent / supervisory authority',
        steps: [corporateSteps.general],
        textfield: true,
        categories: [corporateStepCategories.mainInformation.key],
        required: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.authorizedRegulatedService, answer[field]);
        },
        relevant: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.authorizedRegulatedService, answer[field]);
        },
    },
    licenseNumber: {
        value: 'licenseNumber',
        localization: { id: '', defaultMessage: '' },
        label: 'License number',
        steps: [corporateSteps.general],
        textfield: true,
        categories: [corporateStepCategories.mainInformation.key],
        required: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.authorizedRegulatedService, answer[field]);
        },
        relevant: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.authorizedRegulatedService, answer[field]);
        },
    },
    supervisoryWebsite: {
        value: 'supervisoryWebsite',
        localization: { id: '', defaultMessage: '' },
        label: 'Supervisory website link',
        steps: [corporateSteps.general],
        textfield: true,
        categories: [corporateStepCategories.mainInformation.key],
        required: () => false,
        relevant: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.authorizedRegulatedService, answer[field]);
        },
    },
    countryRelevantAuthorization: {
        value: 'countryRelevantAuthorization',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of relevant authorization',
        steps: [corporateSteps.general],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.mainInformation.key],
        required: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.authorizedRegulatedService, answer[field]);
        },
        relevant: (answers, field = 'value') => {
            const answer = yesNo.yes;
            return includes(answers.authorizedRegulatedService, answer[field]);
        },
        isCountry: true,
    },
    registrationNumber: {
        value: 'registrationNumber',
        localization: { id: '', defaultMessage: '' },
        label: 'Registration/Incorporation number',
        steps: [corporateSteps.general],
        textfield: true,
        categories: [corporateStepCategories.registrationDetails.key],
        required: (_, __, step) => {
            return step === corporateSteps.general.rank;
        },
        relevant: () => false,
    },
    registrationCountry: {
        value: 'registrationCountry',
        localization: { id: '', defaultMessage: '' },
        label: 'Registration/Incorporation country',
        steps: [corporateSteps.general],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.registrationDetails.key],
        required: (_, __, step) => {
            return step === corporateSteps.general.rank;
        },
        relevant: () => false,
        isCountry: true,
    },
    registrationDate: {
        value: 'registrationDate',
        localization: { id: '', defaultMessage: '' },
        label: 'Registration/Incorporation date',
        steps: [corporateSteps.general],
        date: true,
        categories: [corporateStepCategories.registrationDetails.key],
        required: () => true,
        relevant: () => false,
        dateFormat: DateFormat.ddmmyyyySlash,
    },
    country: {
        value: 'country',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of residence',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.contactDetailsHeadOffice.key],
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
        isCountry: true,
        prefixChange: 'phonePrefix',
    },
    city: {
        value: 'city',
        localization: { id: '', defaultMessage: '' },
        label: 'City',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.contactDetailsHeadOffice.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
    },
    postcode: {
        value: 'postcode',
        localization: { id: '', defaultMessage: '' },
        label: 'Postal code',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.contactDetailsHeadOffice.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
    },
    street: {
        value: 'street',
        localization: { id: '', defaultMessage: '' },
        label: 'Street address',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.contactDetailsHeadOffice.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
    },
    phonePrefix: {
        value: 'phonePrefix',
        localization: { id: '', defaultMessage: '' },
        label: 'Phone Code',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.contactDetailsHeadOffice.key],
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
        isCountry: true,
        isPrefix: true,
    },
    phone: {
        value: 'phone',
        localization: { id: '', defaultMessage: '' },
        label: 'Phone',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.contactDetailsHeadOffice.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
        isPhone: true,
    },
    email: {
        value: 'email',
        localization: { id: '', defaultMessage: '' },
        label: 'Email',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.contactDetailsHeadOffice.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
    },
    website: {
        value: 'website',
        localization: { id: '', defaultMessage: '' },
        label: 'Website',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.contactDetailsHeadOffice.key, corporateSteps.beneficiariesDirectors],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === includes(answers.beneficiaryType, answer[field]);
        },
        relevant: (_, __, step) => {
            return step === corporateSteps.general.rank;
        },
    },
    noActivity: {
        value: 'noActivity',
        localization: { id: '', defaultMessage: '' },
        label: 'The company didn’t have activity last year',
        steps: [corporateSteps.financialInformation],
        checkbox: true,
        categories: [corporateStepCategories.financialProfile.key],
        required: (answers, _, __) => {
            return !answers.totalAssets || !answers.totalAssets || !answers.profitsAndLosses;
        },
        relevant: () => true,
    },
    totalAssets: {
        value: 'totalAssets',
        localization: { id: '', defaultMessage: '' },
        label: 'Total assets',
        steps: [corporateSteps.financialInformation],
        textfield: true,
        categories: [corporateStepCategories.financialProfile.key],
        required: (answers) => {
            return !answers.noActivity;
        },
        relevant: () => false,
    },
    totalLiabilities: {
        value: 'totalLiabilities',
        localization: { id: '', defaultMessage: '' },
        label: 'Total liabilities',
        steps: [corporateSteps.financialInformation],
        textfield: true,
        categories: [corporateStepCategories.financialProfile.key],
        required: (answers) => {
            return !answers.noActivity;
        },
        relevant: () => false,
    },
    profitsAndLosses: {
        value: 'profitsAndLosses',
        localization: { id: '', defaultMessage: '' },
        label: 'Profit / Losses',
        steps: [corporateSteps.financialInformation],
        textfield: true,
        categories: [corporateStepCategories.financialProfile.key],
        required: (answers) => {
            return !answers.noActivity;
        },
        relevant: () => false,
    },
    expectedCreditOption: {
        value: 'expectedCreditOption',
        localization: { id: '', defaultMessage: '' },
        label: 'How do you expect to credit/fund your account? Please visit our website for more information on our Rules for Depositing and Withdrawing funds.',
        steps: [corporateSteps.financialInformation],
        options: expectedCreditOptions,
        categories: [corporateStepCategories.meansOfPayment.key],
        required: (_, __, step) => {
            return step === corporateSteps.financialInformation.rank;
        },
        relevant: () => false,
        multipleCheckbox: true,
    },
    nameOfBank: {
        value: 'nameOfBank',
        localization: { id: '', defaultMessage: '' },
        label: 'Name of the institution/bank/transfer company',
        steps: [corporateSteps.financialInformation],
        textfield: true,
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => true,
        relevant: () => false,
        subCategory: corporateSubCategories.detailsOriginOfFunds,
    },
    countryOfOriginFunds: {
        value: 'countryOfOriginFunds',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of origin',
        steps: [corporateSteps.financialInformation],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => true,
        relevant: () => false,
        isCountry: true,
        multiple: () => 2,
        multipleLabel: multipleLabelOptions.origin,
    },
    nameOfBank1: {
        value: 'nameOfBank1',
        localization: { id: '', defaultMessage: '' },
        label: 'Name of the institution/bank/transfer company 2',
        steps: [corporateSteps.financialInformation],
        categories: [corporateStepCategories.meansOfPayment.key],
        textfield: true,
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginFunds1');
        },
    },
    countryOfOriginFunds1: {
        value: 'countryOfOriginFunds1',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of origin 2',
        steps: [corporateSteps.financialInformation],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginFunds1');
        },
        isCountry: true,
        isHidden: true,
    },
    nameOfBank2: {
        value: 'nameOfBank2',
        localization: { id: '', defaultMessage: '' },
        label: 'Name of the institution/bank/transfer company 3',
        steps: [corporateSteps.financialInformation],
        categories: [corporateStepCategories.meansOfPayment.key],
        textfield: true,
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginFunds2');
        },
    },
    countryOfOriginFunds2: {
        value: 'countryOfOriginFunds2',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of origin 3',
        steps: [corporateSteps.financialInformation],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginFunds2');
        },
        isCountry: true,
        isHidden: true,
    },
    nameOfBankDestination: {
        value: 'nameOfBankDestination',
        localization: { id: '', defaultMessage: '' },
        label: 'Name of the institution/bank/transfer company',
        steps: [corporateSteps.financialInformation],
        textfield: true,
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => false,
        relevant: () => true,
        subCategory: corporateSubCategories.expectedPaymentsDestination,
    },
    countryOfOriginDestination: {
        value: 'countryOfOriginDestination',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of origin',
        steps: [corporateSteps.financialInformation],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => false,
        relevant: () => true,
        isCountry: true,
        multiple: () => 2,
        multipleLabel: multipleLabelOptions.destination,
    },
    nameOfBankDestination1: {
        value: 'nameOfBankDestination1',
        localization: { id: '', defaultMessage: '' },
        label: 'Name of the institution/bank/transfer company 2',
        steps: [corporateSteps.financialInformation],
        categories: [corporateStepCategories.meansOfPayment.key],
        textfield: true,
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginDestination1');
        },
    },
    countryOfOriginDestination1: {
        value: 'countryOfOriginDestination1',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of origin 2',
        steps: [corporateSteps.financialInformation],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginDestination1');
        },
        isCountry: true,
        isHidden: true,
    },
    nameOfBankDestination2: {
        value: 'nameOfBankDestination2',
        localization: { id: '', defaultMessage: '' },
        label: 'Name of the institution/bank/transfer company 3',
        steps: [corporateSteps.financialInformation],
        categories: [corporateStepCategories.meansOfPayment.key],
        textfield: true,
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginDestination2');
        },
    },
    countryOfOriginDestination2: {
        value: 'countryOfOriginDestination2',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of origin 3',
        steps: [corporateSteps.financialInformation],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginDestination2');
        },
        isCountry: true,
        isHidden: true,
    },
    countryOfOriginWealth: {
        value: 'countryOfOriginWealth',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of origin',
        steps: [corporateSteps.financialInformation],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => true,
        relevant: () => false,
        isCountry: true,
        multiple: () => 2,
        subCategory: corporateSubCategories.detailsSourceOfWealth,
        multipleLabel: multipleLabelOptions.source,
    },
    countryOfOriginWealth1: {
        value: 'countryOfOriginWealth1',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of origin 2',
        steps: [corporateSteps.financialInformation],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginWealth1');
        },
        isCountry: true,
        isHidden: true,
    },
    countryOfOriginWealth2: {
        value: 'countryOfOriginWealth2',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of origin 3',
        steps: [corporateSteps.financialInformation],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.meansOfPayment.key],
        required: () => false,
        relevant: (_, __, ___, hidden) => {
            return includes(hidden, 'countryOfOriginWealth2');
        },
        isCountry: true,
        isHidden: true,
    },
    declarationBeneficialOwner: {
        value: 'declarationBeneficialOwner',
        localization: { id: '', defaultMessage: '' },
        label: 'Declaration of Ultimate Beneficial Owner',
        steps: [corporateSteps.signing],
        file: true,
        required: () => true,
        relevant: () => false,
    },
    resolutionDirectors: {
        value: 'resolutionDirectors',
        localization: { id: '', defaultMessage: '' },
        label: 'A resolution by the Board of Directors of the Company to appoint Representative of the Company',
        steps: [corporateSteps.signing],
        file: true,
        required: () => true,
        relevant: () => false,
    },
    phoneIndividualPrefix: {
        value: 'phoneIndividualPrefix',
        localization: { id: '', defaultMessage: '' },
        label: 'Phone Code',
        steps: [corporateSteps.beneficiariesDirectors],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.contactDetails.key],
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return step === corporateSteps.representative.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
        isCountry: true,
        isPrefix: true,
    },
    phoneIndividual: {
        value: 'phoneIndividual',
        localization: { id: '', defaultMessage: '' },
        label: 'Phone',
        steps: [corporateSteps.beneficiariesDirectors],
        categories: [corporateStepCategories.contactDetails.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return step === corporateSteps.representative.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
        isPhone: true,
    },
    phoneRepresentative: {
        value: 'phoneRepresentative',
        localization: { id: '', defaultMessage: '' },
        label: 'Phone',
        steps: [corporateSteps.representative],
        categories: [corporateStepCategories.contactDetails.key],
        textfield: true,
        required: (_, __, step) => {
            return step === corporateSteps.representative.rank;
        },
        relevant: () => false,
        isPhone: true,
        memberField: (step) => {
            return step === corporateSteps.representative.rank && 'phone';
        },
    },
    emailIndividual: {
        value: 'emailIndividual',
        localization: { id: '', defaultMessage: '' },
        label: 'Email',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.contactDetails.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return step === corporateSteps.representative.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
        memberField: (step) => {
            return step === corporateSteps.representative.rank && 'email';
        },
        disabled: (step) => {
            return step === corporateSteps.representative.rank;
        },
    },
    countryAddress: {
        value: 'countryAddress',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of residence',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.contactDetailsAddress.key],
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return step === corporateSteps.representative.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
        isCountry: true,
        prefixChange: 'phoneIndividualPrefix',
        memberField: (step) => {
            return step === corporateSteps.representative.rank && 'address.country';
        },
    },
    cityAddress: {
        value: 'cityAddress',
        localization: { id: '', defaultMessage: '' },
        label: 'City',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.contactDetailsAddress.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return step === corporateSteps.representative.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
    },
    postcodeAddress: {
        value: 'postcodeAddress',
        localization: { id: '', defaultMessage: '' },
        label: 'Postal code',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.contactDetailsAddress.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return step === corporateSteps.representative.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
    },
    streetAddress: {
        value: 'streetAddress',
        localization: { id: '', defaultMessage: '' },
        label: 'Street address',
        steps: [corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.contactDetailsAddress.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.individual;
            return step === corporateSteps.representative.rank || includes(answers.beneficiaryType, answer[field]);
        },
        relevant: () => false,
    },
    correspondenceAddress: {
        value: 'correspondenceAddress',
        localization: { id: '', defaultMessage: '' },
        label: 'Same as the head office address',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        checkbox: true,
        categories: [corporateStepCategories.correspondenceAddress.key],
        required: () => false,
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank;
        },
        defaultChecked: true,
    },
    correspondenceCountry: {
        value: 'correspondenceCountry',
        localization: { id: '', defaultMessage: '' },
        label: 'Country of residence',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        categories: [corporateStepCategories.correspondenceAddress.key],
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
        isCountry: true,
        prefixChange: 'correspondencePhonePrefix',
    },
    correspondenceCity: {
        value: 'correspondenceCity',
        localization: { id: '', defaultMessage: '' },
        label: 'City',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.correspondenceAddress.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
    },
    correspondencePostcode: {
        value: 'correspondencePostcode',
        localization: { id: '', defaultMessage: '' },
        label: 'Postal code',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.correspondenceAddress.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
    },
    correspondenceStreet: {
        value: 'correspondenceStreet',
        localization: { id: '', defaultMessage: '' },
        label: 'Street address',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.correspondenceAddress.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
    },
    correspondencePhonePrefix: {
        value: 'correspondencePhonePrefix',
        localization: { id: '', defaultMessage: '' },
        label: 'Phone Code',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.correspondenceAddress.key],
        dropdown: true,
        options: filter(countries, (country) => !country.forbidden),
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
        isCountry: true,
        isPrefix: true,
    },
    correspondencePhone: {
        value: 'correspondencePhone',
        localization: { id: '', defaultMessage: '' },
        label: 'Phone',
        steps: [corporateSteps.general, corporateSteps.beneficiariesDirectors, corporateSteps.representative],
        categories: [corporateStepCategories.correspondenceAddress.key],
        textfield: true,
        required: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
        relevant: (answers, field = 'value', step) => {
            const answer = beneficiaryTypeOptions.company;
            return !answers.correspondenceAddress &&
                (step === corporateSteps.general.rank || includes(answers.beneficiaryType, answer[field]) || step === corporateSteps.representative.rank);
        },
        isPhone: true,
    },
}));
